function newRelic () {
  const { host } = window.location
  const featureRegex = new RegExp(/^.*\.feature\.zavasrv\.com$/)
  if (host === 'www.zavamed.com' || host === 'onlinedoctor.superdrug.com' || host === 'www.dred.com' || host === 'onlinedoctor.asda.com') {
    window.newRelicConfig = { // Production Env
      appId: '140884995',
      accId: '70139',
      agentId: '140884995',
      licenseKey: 'NRBR-1833c06ea501072a42d',
      cookiesEnabled: false,
      denyList: ['bam-cell.nr-data.net']
    }
  } else if (host === 'zava-preview.zavamed.com' || host === 'preview.dred.com' || host === 'sd-preview.dred.com' || host === 'preview.onlinedoctor.asda.com') {
    window.newRelicConfig = { // Staging Env
      appId: '1834981686',
      accId: '3336407',
      agentId: '1834981686',
      licenseKey: 'NRJS-903921c593d9c29e580',
      cookiesEnabled: true,
      denyList: ['bam.nr-data.net']
    }
  } else if (featureRegex.test(host)) {
    window.newRelicConfig = { // Feature Env
      appId: '1834981689',
      accId: '3336407',
      agentId: '1834981689',
      licenseKey: 'NRBR-2740bd10dead28d5942',
      cookiesEnabled: true,
      denyList: ['bam.nr-data.net']
    }
  }
}

newRelic()
export default newRelic // Purely for testing purposes
